module.exports = __webpack_public_path__ + "static/media/TVHH_4-Pharmacy.e68bf96c.mp4";